import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";



export const getBusinessDetails = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.getBusiness,
    data,
    true
  );
};